export const APPLICATION_NAME = "Evidence Tool";

export const createPageTitle = (title?: string) =>
  title ? `${title} | ${APPLICATION_NAME}` : APPLICATION_NAME;
